import React from 'react';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  Box,
  Chip,
  Divider,
  Stack,
  Typography
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDateTime } from '../../../services/functions';

export const TfgFeedLogs = ({ logs }) => {
  if (!logs?.length) {
    return (
      <Alert severity="info">
        Brak logów.
      </Alert>
    );
  }

  const renderData = data => {
    if (!data) {
      return null;
    }

    return (
      <Box
        component="pre"
        sx={{
          overflow: 'auto',
          p: 2,
          bgcolor: 'grey.100',
          borderRadius: 1,
          fontSize: 13,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      >
        {typeof data === 'string'
          ? data
          : JSON.stringify(data, null, 2)}
      </Box>
    );
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h6">
        Historia komunikacji
      </Typography>

      {logs.map(log => (
        <Accordion key={log.id}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ width: '100%' }}
            >
              <Typography sx={{ minWidth: 180 }}>
                {formatDateTime(log.created_at)}
              </Typography>

              {log.status && (
                <Chip
                  size="small"
                  label={log.status}
                />
              )}

              {log.http_status && (
                <Chip
                  size="small"
                  label={log.http_status}
                  color={log.http_status >= 400 ? 'error' : 'default'}
                />
              )}

              {log.error_type && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  {log.error_type}
                </Typography>
              )}

              {log.error && (
                <Typography
                  variant="body2"
                  color="error"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {log.error}
                </Typography>
              )}
            </Stack>
          </AccordionSummary>

          <AccordionDetails>
            <Stack spacing={3}>
              {log.error && (
                <Box>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    color="error"
                  >
                    Błąd
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  <Alert severity="error">
                    <Typography
                      sx={{
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                      }}
                    >
                      {log.error}
                    </Typography>
                  </Alert>
                </Box>
              )}

              {log.error_type && (
                <Box>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                  >
                    Typ błędu
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  <Typography variant="body2">
                    {log.error_type}
                    {log.http_status && ` (${log.http_status})`}
                  </Typography>
                </Box>
              )}

              {log.request_data && (
                <Box>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                  >
                    Request
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  {renderData(log.request_data)}
                </Box>
              )}

              {log.response_data && (
                <Box>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                  >
                    Response
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  {renderData(log.response_data)}
                </Box>
              )}

              {log.validation_errors && (
                <Box>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                  >
                    Błędy walidacji
                  </Typography>

                  <Divider sx={{ mb: 1 }} />

                  {renderData(log.validation_errors)}
                </Box>
              )}
            </Stack>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
};

export default TfgFeedLogs;
